import { MUTATIONS, SET_NUBE } from './mutations';
import { SET_NEW_PDP_CONSENT_MODAL_VISIBLE } from '@/store/mutations';
import parceSnils from '@/tools/parceSnils';
import { format } from 'date-fns';

const INIT = 'init';
const PROFILE = 'profile';
const SIGNIN = 'signin';
const ESSIA_SIGNIN = 'essia_signin';
const ESSIA_SIGNIN_NEW = 'essia_signin_new';
const SIGNOUT = 'signout';
const SIGNUP = 'signup';
const ESIA_SIGNUP = 'esiaSignup';
const FORGET = 'forget';
const REFRESH_TOKEN = 'refreshToken';
const CHANGE_PASSWORD = 'password';
const UPDATE_PROFILE = 'updateProfile';
const GET_CHILDREN = 'children';
const GET_CHILD = 'getChild';
const SAVE_CHILD = 'saveChild';
const DELETE_CHILD = 'deleteChild';

export const ACTIONS = {
  INIT,
  PROFILE,
  SIGNIN,
  SIGNOUT,
  SIGNUP,
  FORGET,
  REFRESH_TOKEN,
  CHANGE_PASSWORD,
  UPDATE_PROFILE,
  GET_CHILDREN,
  GET_CHILD,
  SAVE_CHILD,
  DELETE_CHILD,
};

const toDate = (value, a, b) => (value || '').split(a).reverse().join(b);
const toUtc = (value) => toDate(value, '.', '-');

const createActions = function ({ $auth, $api }) {
  return {
    [INIT]: ({ commit, dispatch }) => {
      return dispatch(PROFILE);
    },
    // TODO: надо перевести формы на AppForm и по нормальному работать с данными с форм без кучи преобразований
    [SIGNUP]: ({ dispatch, commit }, payload) => {
      const {
        email,
        password,
        first_name,
        last_name,
        patro_name,
        municipality_id,
        study_places,
        phone,
        password_confirm,
        is_consent_data,
        birthday,
        sex,
        snils,
        edu_level_id,
        region_id,
        is_accepted_consent_pdp,
      } = payload;
      const data = {
        email,
        password,
        password_confirm,
        first_name,
        last_name,
        patro_name,
        municipality_id,
        places_study: study_places,
        phone,
        is_consent_data,
        birthday,
        sex,
        snils,
        edu_level_id,
        region_id,
        is_accepted_consent_pdp,
      };
      return $api
        .post('profile/register', { data })
        .then((res) => {
          commit(SET_NUBE, true);
          return dispatch(SIGNIN, { email, password });
        })
        .catch((err) =>
          Promise.reject(
            err.response && err.response.data ? err.response.data.errors : []
          )
        );
    },

    [SIGNIN]: ({ dispatch }, payload) => {
      const { email, password } = payload;
      return $api
        .post('auth/login', { data: { email, password } })
        .then((res) => dispatch(INIT))
        .catch((err) =>
          Promise.reject(
            err.response && err.response.data ? err.response.data.errors : []
          )
        );
    },
    [ESSIA_SIGNIN]: ({ dispatch }, payload) => {
      return $api
        .post('esia/auth', { data: payload })
        .then((res) => dispatch(INIT))
        .catch((err) =>
          Promise.reject(
            err.response && err.response.data ? err.response.data.errors : []
          )
        );
    },

    [ESSIA_SIGNIN_NEW]: ({ dispatch }, payload) => {
      return $api
        .post('esia/auth', { data: payload })
        .then((res) => dispatch(INIT))
        .catch((err) =>
          Promise.reject(
            err.response && err.response.data ? err.response.data : {}
          )
        );
    },

    [ESIA_SIGNUP]: ({ dispatch }, payload) => {
      return $api
        .post('esia/get/params', { data: { code: payload } })
        .then(({ data: { data } = {} }) => {
          if (!data.redirect_url) {
            dispatch(INIT);
          }
          return data;
        })
        .catch((err) =>
          Promise.reject(
            err.response && err.response.data ? err.response.data.errors : []
          )
        );
    },

    [REFRESH_TOKEN]: ({}, payload) => {
      return $api.post('auth/token/refresh', {
        data: { refresh_token: payload },
      });
    },

    [SIGNOUT]: ({ commit }) => {
      return $api.post('auth/logout').then(() => {
        commit(SET_NUBE);
        commit(MUTATIONS.CLEAR_PROFILE); // На эту мутацию повешен слушатель для логаута
        commit(SET_NEW_PDP_CONSENT_MODAL_VISIBLE, false, { root: true });
      });
    },

    [FORGET]: ({}, email) => {
      return $api.post('auth/password/forget', { data: { email } });
    },

    [CHANGE_PASSWORD]: ({}, password) => {
      return $api.post('profile/password/change', { data: { password } });
    },

    [PROFILE]: ({ commit }, payload) => {
      commit(MUTATIONS.SET_LOADING, true);
      return $api
        .get('profile/get')
        .then(({ data: { data } = {} }) => {
          commit(MUTATIONS.SET_PROFILE, {
            ...data,
            snils: parceSnils(data.snils),
            birthday:
              data && data.birthday ? format(data.birthday, 'DD.MM.YYYY') : '',
          });
          commit(MUTATIONS.SET_LOADING, false);
          commit(MUTATIONS.PROFILE_LOADED, true);
          commit(
            SET_NEW_PDP_CONSENT_MODAL_VISIBLE,
            !!(data && data.is_need_concent_new_pdp === true),
            { root: true }
          );
          return data;
        })
        .catch((err) => {
          commit(MUTATIONS.SET_LOADING, false);
          commit(MUTATIONS.PROFILE_LOADED, true);
          return Promise.resolve();
        });
    },

    [UPDATE_PROFILE]: (
      { commit },
      {
        email,
        first_name,
        last_name,
        patro_name,
        municipality_id,
        phone,
        birthday,
        edu_level_id,
        sex,
        work,
        position,
        address,
        zip_code,
        prof_spheres,
        professions,
        competences,
        roles,
        snils,
        places_study,
        places_work,
        access_permissions,
        region_id,
        citizenship,
        is_russian_work_permission,
        address_match,
        residence_registration_match,
        address_zip,

        // ADDITIONAL DATA
        about_me,
        key_skills,
        is_car,
        site,
        drivers_license,
        native_language,
        foreign_language,
        // END-OF ADDITIONAL DATA
        desired_position,
        employment_id,
        work_schedule_id,
        salary,
        is_ovz_adaptation,
        is_willing_travel,
        is_willing_relocate,
        is_housing_needed,
      }
    ) => {
      const data = {
        email,
        first_name,
        last_name,
        patro_name,
        region_id,
        municipality_id,
        phone,
        birthday: birthday && birthday.length ? toUtc(birthday) : undefined,
        edu_level_id,
        sex,
        work,
        position,
        address,
        zip_code,
        prof_spheres,
        professions,
        competences,
        roles,
        snils: snils && snils.length ? snils.replace(/\s|-/g, '') : undefined,
        places_study,
        places_work,
        access_permissions,
        citizenship,
        is_russian_work_permission,
        address_match,
        residence_registration_match,
        address_zip,
        desired_position,
        employment_id,
        work_schedule_id,
        salary,
        is_ovz_adaptation,
        is_willing_travel,
        is_willing_relocate,
        is_housing_needed,

        // ADDITIONAL DATA
        about_me,
        key_skills,
        is_car,
        site,
        drivers_license,
        native_language,
        foreign_language,
        // END-OF ADDITIONAL DATA
      };

      return $api
        .post('profile/update', { data })
        .then(({ data: { data } = {} }) => {
          console.log('SEE', data);
          commit(MUTATIONS.SET_PROFILE, {
            ...data,
            snils: parceSnils(data.snils),
            birthday:
              data && data.birthday ? format(data.birthday, 'DD.MM.YYYY') : '',
          });
          return data;
        })
        .catch((err) => {
          return Promise.reject(
            err.response && err.response.data ? err.response.data.errors : []
          );
        });
    },
  };
};

export default createActions;



// WEBPACK FOOTER //
// ./src/store/user/actions.js